import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse, HttpRequest,  HttpParams, HttpEvent } from '@angular/common/http';
import { Router } from '@angular/router';
import 'rxjs/add/operator/catch';
import { API_URL } from '../../../utils/constants';
import {Cookie} from 'ng2-cookies';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import { catchError } from 'rxjs/operators';
import {Observable, Subject, asapScheduler, pipe, of, from, interval, merge, fromEvent, throwError} from 'rxjs';
import {AuthService} from '../../guard/auth.service';

@Injectable()
export class ApiRequestService {

    constructor(
        public  authService: AuthService,
        private http: HttpClient,
        private router: Router
    ) {}

    /**
     * This is a Global place to add all the request headers for every REST calls
     */
    getHeaders(): HttpHeaders {
        let headers = new HttpHeaders();
        let token = Cookie.get('access_token');
         headers = headers.append('Content-Type', 'application/json');
        if (token !== null) {
            headers = headers.append("Authorization", 'Bearer ' + token);
        }
        return headers;
    }

  getExt(url: string, urlParams?: HttpParams): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    return this.http.get(  url, {headers: headers} )
        .pipe(
            catchError(this.authService.errorHandler));

      // .catch((error) => {
      //   console.log("Some error in catch");
      //   return Observable.throw(error || 'Server error');
      // });
  }

    get(url: string, urlParams?: HttpParams): Observable<any> {
        let me = this;
        return this.http.get(API_URL + url, {headers: this.getHeaders(),  params: urlParams} )
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    if (error.status === 401) {
                        //console.log( '  errorHandler:' + 401);
                        //this.authService.logout();
                        this.router.navigate(['/login']);
                    }
                    //window.alert(errorMessage);
                    return throwError('');
                })


            );
            // .pipe(
            //     catchError(this.authService.errorHandler));



            // .catch((error) => {
            //     console.log("Some error in catch");
            //     if (error.status === 401 || error.status === 403) {
            //         me.router.navigate(['/']);
            //     }
            //     return Observable.throw(error || 'Server error');
            // });
    }

    post(url:string, body:Object):Observable<any>{
        let me = this;
        return this.http.post(API_URL + url, JSON.stringify(body), { headers:this.getHeaders()})
            .pipe(
                catchError(this.errorHandler));
            // .catch(function(error:any){
            //     if (error.status === 401){
            //         me.router.navigate(['/']);
            //     }
            //     return Observable.throw(error || 'Server error')
            // });
    }

  postFile(url: string, file: File, app: string, platform: string, bundle: string, version: string, title: string): Observable<HttpEvent<{}>> {
    let me = this;
    const formdata: FormData = new FormData();
    formdata.append('file', file);
      formdata.append('app', app);
      formdata.append('version', version);
      formdata.append('title', title);
      formdata.append('platform', platform);
      formdata.append('bundle', bundle);

      const req = new HttpRequest('POST', url, formdata,
      {
      reportProgress: true,
      responseType: 'text'
    });

    const authReq = req.clone({
      setHeaders: { Authorization: 'Bearer ' + Cookie.get('access_token') }
    });

    return this.http.request(authReq);

    // return this.http.post(API_URL + url, formdata, {
    //     headers: this.getHeaders(),
    //     reportProgress: true,
    //     responseType: 'text'
    //   })
    //   .catch(function(error:any){
    //     if (error.status === 401){
    //       me.router.navigate(['/logout']);
    //     }
    //     return Observable.throw(error || 'Server error');
    //   });
  }

    put(url: string, body: Object): Observable<any>{
        let me = this;
        return this.http.put(API_URL + url, JSON.stringify(body), { headers: this.getHeaders()})
            .pipe(
                catchError(this.authService.errorHandler));
            // .catch(function(error:any){
            //     if (error.status === 401){
            //         me.router.navigate(['/']);
            //     }
            //     return Observable.throw(error || 'Server error')
            // });
    }

    delete(url: string): Observable<any>{
        let me = this;
        return this.http.delete(API_URL + url, { headers: this.getHeaders()})
            .pipe(
                catchError(this.authService.errorHandler));
            // .catch(function(error:any){
            //     if (error.status === 401){
            //         me.router.navigate(['/']);
            //     }
            //     return Observable.throw(error || 'Server error')
            // });
    }



    errorHandler(error: HttpErrorResponse) {
        //return throwError(error.message || "Server Error")
        if (error.status === 401) {
            //console.log( '  errorHandler:' + 401);
                 //this.authService.logout();
                    this.router.navigate(['/login']);
                }
                return Observable.throw(error || 'Server error');
    }

}
